import { createRoot } from "react-dom/client";
import { createElement } from "react";

const activeRoots = new Map();

export function mountReactIsland(selector, Component, options = {}) {
  const container = document.querySelector(selector);
  if (!container) return null;

  if (activeRoots.has(selector)) {
    activeRoots.get(selector).unmount();
  }

  let domProps = {};
  const propsScript = options.propsSelector
    ? document.querySelector(options.propsSelector)
    : container.querySelector('script[type="application/json"]');

  if (propsScript?.textContent) {
    try {
      domProps = JSON.parse(propsScript.textContent);
    } catch (e) {
      console.error(`[ReactIsland] Failed to parse props for ${selector}`, e);
    }
  }

  const mergedProps = { ...domProps, ...options.props };
  const root = createRoot(container);
  root.render(createElement(Component, mergedProps));
  activeRoots.set(selector, root);
  return root;
}

export function unmountReactIsland(selector) {
  const root = activeRoots.get(selector);
  if (root) {
    root.unmount();
    activeRoots.delete(selector);
  }
}

let islandCounter = 0;

export function unmountAllIslands() {
  activeRoots.forEach((root) => root.unmount());
  activeRoots.clear();
}

export function mountAllIslands(registry) {
  document.querySelectorAll("[data-react-island]").forEach((el) => {
    const name = el.getAttribute("data-react-island");
    if (name && registry[name]) {
      if (!el.id) {
        el.id = `react-island-${name}-${islandCounter++}`;
      }
      mountReactIsland(`#${el.id}`, registry[name]);
    }
  });
}
